"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValue = exports.updateDestination = exports.isDestinationDelivery = void 0;
function isDestinationDelivery(destination) {
    return destination.delivery !== undefined;
}
exports.isDestinationDelivery = isDestinationDelivery;
const updateDestination = (current, key, value) => {
    const currentValue = current.delivery;
    const currentIndex = currentValue.findIndex((row) => row.key === key);
    if (currentIndex !== -1) {
        const copy = [...currentValue];
        copy.splice(currentIndex, 1, { key, value });
        return { delivery: copy };
    }
    else {
        return {
            delivery: currentValue.concat([{ key, value }]),
        };
    }
};
exports.updateDestination = updateDestination;
const getValue = (current, key) => {
    const { value } = current.find((row) => row.key === key) || {
        value: undefined,
    };
    return value;
};
exports.getValue = getValue;
//# sourceMappingURL=destination.js.map